"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeScrollLock = exports.addScrollLock = void 0;
const SCROLL_LOCK_CLASS_NAME = 'cds-HtmlElement--ScrollLock';
const addScrollLock = () => {
  const htmlTag = document.querySelector('html');
  htmlTag?.classList.add(SCROLL_LOCK_CLASS_NAME);
};
exports.addScrollLock = addScrollLock;
const removeScrollLock = () => {
  const htmlTag = document.querySelector('html');
  htmlTag?.classList.remove(SCROLL_LOCK_CLASS_NAME);
};
exports.removeScrollLock = removeScrollLock;
//# sourceMappingURL=scrollLock.js.map